import { predictedProcessStepsAdapter } from "#modules/quoteRequestLines/adapters/predictedProcessStepsAdapter";
import { useProcessStepCatalog } from "#modules/quoteRequestLines/view/useProcessStepCatalog";
import { useSurfaceTreatmentsPredictions } from "#modules/quoteRequestLines/view/useSurfaceTreatmentsPredictions";
import { defaultFilterProcessSteps } from "#modules/quoteRequestLines/views/DetailsPanel/ProcessSteps/useProcessStepsSelect";
import { IndustrialProcessType, MaterialGradeType } from "shared";

export const useProcessSteps = ({
  quoteRequestLineId,
  materialGrade,
  filterProcessSteps = defaultFilterProcessSteps,
}: {
  filterProcessSteps?: <T extends { industrialProcess: IndustrialProcessType }>(
    processSteps: T[],
  ) => T[];
  quoteRequestLineId: string | undefined;
  materialGrade: MaterialGradeType;
}) => {
  const { surfaceTreatmentsPredictions } = useSurfaceTreatmentsPredictions(quoteRequestLineId);

  const { processStepCatalog } = useProcessStepCatalog(materialGrade);
  const additionalAndSurfaceTreatmentProcessSteps = [
    ...processStepCatalog,
    ...surfaceTreatmentsPredictions,
  ];

  const allPredictedProcessSteps = predictedProcessStepsAdapter(
    additionalAndSurfaceTreatmentProcessSteps,
  );

  const filteredPredictedProcessSteps = filterProcessSteps(allPredictedProcessSteps);

  const filteredAdditionalProcessSteps = filterProcessSteps(
    additionalAndSurfaceTreatmentProcessSteps,
  );

  return {
    allPredictedProcessSteps: filteredPredictedProcessSteps,
    additionalProcessSteps: filteredAdditionalProcessSteps,
  };
};
